export default "__VITE_ASSET__ChFs6Put__"